import { AlertIcon } from '@approvalmax/ui';
import { Alert, Link } from '@approvalmax/ui/src/components';
import { actions, selectors } from 'modules/common';
import { useDispatch, useSelector } from 'modules/react-redux';
import { qbooksMatchingHelpItemId } from 'pages/requestList/constants';
import { memo } from 'react';

import { qbooksMatchingUrL, qbooksMatchingVideoUrl } from './MatchingPopupLinks.constants';
import { messages } from './MatchingPopupLinks.messages';

export const MatchingPopupLinks = memo(() => {
    const dispatch = useDispatch();

    const hiddenHelpItems = useSelector(selectors.userPreferences.getHiddenHelpItems);
    const showHelpSection = !hiddenHelpItems.includes(qbooksMatchingHelpItemId);

    const onHideHelpSection = () => {
        dispatch(actions.updateHiddenHelpItem(qbooksMatchingHelpItemId, true));
    };

    return (
        <Alert
            color='midnight20'
            closable
            startIcon={<AlertIcon />}
            alignItems='center'
            onClose={onHideHelpSection}
            open={showHelpSection}
        >
            {messages.learMoreText({
                learnMoreLink: (
                    <Link external font='body' href={qbooksMatchingUrL}>
                        {messages.learnMoreLinkText}
                    </Link>
                ),
            })}

            <br />

            {messages.videoText({
                videoLink: (
                    <Link external font='body' href={qbooksMatchingVideoUrl}>
                        {messages.videoUrl}
                    </Link>
                ),
            })}
        </Alert>
    );
});

MatchingPopupLinks.displayName = 'MatchingPopupLinks';
